import { Component, Mixins, Prop, VModel } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'

import ProjectUser from '@/views/Authorization/models/projectUser'
import User from '@/views/User/models/user'
import Role from '@/views/Authorization/models/role'

@Component
export default class UserCheckbox extends Mixins<MixinInterface>() {
    @VModel() disabledBox!: boolean
    @Prop() projectUser!: ProjectUser | null
    @Prop() newUser!: User | string | null
    @Prop({ required: true }) role!: Role
    @Prop({ default: true }) disabled!: boolean
    @Prop({ required: true }) roles!: Array<Role>
    @Prop() contractor!: { id: string; name: string }

    loading = false

    get checked() {
        return this.projectUser && this.role._id ? this.projectUser.hasRole(this.role._id) : false
    }

    async toggleRole() {
        if (!this.disabledBox && !this.disabled) {
            this.disabledBox = true
            this.loading = true

            if (this.projectUser && this.role._id) {
                await this.projectUser.toggleRole(this.role._id)
            } else {
                await ProjectUser.initiatePostProjectUser(
                    this.newUser,
                    this.role,
                    this.currentProject,
                    this.roles,
                    this.contractor
                )
            }

            this.loading = false
            this.disabledBox = false
        }
    }
}
